<mat-dialog-content>
    <div>
        <h3>Update Booking for {{ availability?.date | date: 'MMMM dd, yyyy' }}</h3>
        <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Reservation Type</mat-label>
                <mat-select [(ngModel)]="reason">
                    <mat-option [value]="null">Select type</mat-option>
                    <mat-option *ngFor="let r of reasons" [value]="r">
                        {{ r }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Blocked Reason</mat-label>
                <input matInput [(ngModel)]="blockedReason" />
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-raised-button color="warning" (click)="onCancel()">
        <mat-icon matPrefix>cancel</mat-icon> Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onSave()">
        <mat-icon matPrefix>save</mat-icon> Update
    </button>
</mat-dialog-actions>